import $ from 'jquery';
import {ShareTypeEnum, ShareTypeProcessingEnum} from '../../enums/ShareTypeEnum';

function getContent(selector, attr = 'content') {
    const element = document.querySelector(selector);
    return element ? encodeURIComponent(element.getAttribute(attr)) : '';
}

/**
 * ShareV1 widget configs
 */
const shareV1Semantics = {
    'mainWrapClass': 'share-v1',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'elementClass': 'share-v1__item',
    'successClass': 'share-v1__success',
    'errorClass': 'share-v1__error',
};

/**
 * ShareV1 initializer
 */
$(function () {
    ShareV1.init();
});

class ShareV1 {
    constructor() {
        this.pluginInstances = {};
    }

    static init(reInit = false) {
        let instances = $(`.${shareV1Semantics.mainWrapClass}`);
        if (instances.length === 0) {
            return false;
        }

        if (!window || !window.widgets || !window.widgets.shareV1) {
            window.widgets.shareV1 = new ShareV1();
        }

        /**
         * Checking other instances
         */
        instances.each((index, el) => {
            let isInitialized =
                ($(el).attr(`${shareV1Semantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized || reInit) {
                window.widgets.shareV1.registerInstance($(el));
                window.widgets.shareV1.registerListeners($(el));
            }
        });
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${shareV1Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }
        try {
            // TODO[dependDetected]: slick plugin
            let object = el.find(`.${shareV1Semantics.mainWrapClass}`);
            el.attr(`${shareV1Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = object;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerListeners(el) {
        let elements = $(`.${shareV1Semantics.mainWrapClass}[${
                shareV1Semantics
                        .instanceIdAttribute
        }="${
                el.attr(shareV1Semantics
                        .instanceIdAttribute)
        }"]`);

        elements.on(
            'click',
            `.${shareV1Semantics.elementClass}`,
            (e) => {
                e.preventDefault();
                let current = $(e.currentTarget);
                let objectName = current.attr('data-name-id');
                //let shareLink = current.attr('data-share'); //пока не пригодилось

                let result = ShareTypeEnum[objectName].callback(this.computedSetups());
                //Процессинг пока делаем как можно проще
                switch (result.typeProcessing) {
                    case ShareTypeProcessingEnum.clipboard:
                        if (navigator.clipboard && navigator.clipboard.writeText) {
                            navigator.clipboard.writeText(decodeURIComponent(result.url)).then(() => {
                                current.find('span').text('Скопировано').addClass(shareV1Semantics.successClass);
                            }).catch(err => {
                                current.find('span').text('Ошибка').addClass(shareV1Semantics.errorClass);
                            });
                        } else {
                            current.find('span').text('Ошибка').addClass(shareV1Semantics.errorClass);
                        }
                        break;
                    case ShareTypeProcessingEnum.window:
                        window.open(result.url, 'ShareWindow', 'width=600, height=400');
                        break;
                }
            }
        );
    }

    computedSetups() {
        return {
            'location': encodeURIComponent(window.location.href),
            'title': getContent('meta[property="og:title"]') || encodeURIComponent(document.title),
            'description': getContent('meta[property="og:description"]') || getContent('meta[name="description"]'),
            'imageUrl': getContent('meta[property="og:image"]'),
        }
    }

    reInit(instanceId) {
        ShareV1.init(true);
    }
}